import * as yup from "yup"
import { Tecnica } from "../../types"

export function initialValuesTecnica(tecnica?: Tecnica | undefined) {
  if (tecnica) {
    return tecnica
  }
  return {
    nome: "",
  }
}

export function validationSchemaTecnica() {
  return yup.object().shape({
    nome: yup.string().required("Campo obbligatorio"),
  })
}
